// extracted by mini-css-extract-plugin
module.exports = {"ReplacementSection":"ReplacementParts_ReplacementSection__z2J88"};